import { useEffect } from 'react';

import { useHasLoggedOut } from '../../context/AuthMachine';
import { useLiveActivity } from '../../integrations';

/**
 * A small hook that cancels all live activities when the user logs out.
 */
export const useCancelLiveActivitiesOnLogout = () => {
  const hasSignedOut = useHasLoggedOut();
  const { cancelAllLiveActivities } = useLiveActivity();

  useEffect(() => {
    if (!hasSignedOut) return;

    cancelAllLiveActivities();
  }, [cancelAllLiveActivities, hasSignedOut]);
};
